module.exports = __webpack_public_path__ + "assets/img/tx101s.1def888a.jpg";